export const MediaFormat = {
  profileImageMaxSize: 20971520, //20MB - //2097152, // 2Mb (Bytes)
  otherImagesMaxSize: 20971520, //20MB - //2097152, // 2Mb (Bytes),
  videoMaxSize: 20971520, //20MB - //2097152, // 2Mb (Bytes),
  docMaxSize: 20971520, //20MB - //2097152, // 2Mb (Bytes),
  imageFormats: '.png,.jpg', //.jpeg removed for now 23/9,
  countyFormats: '.pdf, .jpg, .png',
  wordFileFormat: '.doc,.docx',
  pdfFormat: '.pdf',
  videoFormat: '.mkv,.mp4,.webm,.mov',
  excelFormat: '.xls,.xlsx',
  csvFormat: '.csv',
  mdbFormat: '.mdb',
  allDocFormat: '.pdf,.doc,.docx,.xls,.xlsx,.mdb',
  allFormat: () => {
    return MediaFormat.imageFormats + ',' + MediaFormat.allDocFormat; //+ ',' + MediaFormat.videoFormat // as for now video is not included
  },
  imageTypeEnum: 1,
  excelTypeEnum: 2,
  csvTypeEnum: 2,
  wordTypeEnum: 3,
  pdfTypeEnum: 4,
  videoTypeEnum: 5,
  mdbTypeEnum: 6,
  actualTypeConst: {
    ProfilePicture: 1,
    mdbFile: 2,
    Other: 6
  },
  maxFileSizeMultiple: 9999
}
